import reduceReducers from 'reduce-reducers'
import fetchReducer from './fetch'

export default reduceReducers(fetchReducer)
